import React, { useState, useEffect } from "react";
import { Link, Route, Routes } from "react-router-dom";
import { ref as databaseRef, get, set } from "firebase/database";
import "./Home.css";
import Chat from "./Chat";
import { FaCircleQuestion, FaCopy, FaPlus, FaXmark } from "react-icons/fa6";
import Header from "./Header";

export default function Home(props) {
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [addUserButtonDisabled, setAddUserButtonDisabled] = useState(false);
  const [newContact, setNewContact] = useState("");
  const [contactToAdd, setContactToAdd] = useState(null);
  const [confirmingContact, setConfirmingContact] = useState(false);

  function getGreeting() {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return "Good Morning!";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "Good Afternoon!";
    } else {
      return "Good Night!";
    }
  }

  function formatTimestamp(timestamp) {
    const currentTimestamp = Date.now();
    const timeDifferenceInHours = (currentTimestamp - timestamp) / (1000 * 60 * 60);

    if (timeDifferenceInHours < 24) {
      return new Date(timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } else if (timeDifferenceInHours < 48) {
      return "Yesterday";
    } else {
      return new Date(timestamp).toLocaleDateString();
    }
  }

  useEffect(() => {
    try {
      if (addUserButtonDisabled) {
        document.getElementById("addUserIdOkbtn")?.style?.setProperty("background", "grey");
        document.getElementById("addUserIdOkbtn")?.style?.setProperty("cursor", "no-drop");
      } else {
        document.getElementById("addUserIdOkbtn")?.style?.setProperty("background", "blue");
        document.getElementById("addUserIdOkbtn")?.style?.setProperty("cursor", "pointer");
      }
    } catch (error) {
      console.error(error);
    }
  }, [addUserButtonDisabled]);

  const addContact = async (event) => {
    event.preventDefault();
    setAddUserButtonDisabled(true);

    try {
      const snapshot = await get(databaseRef(props.db, `users/${newContact}`));

      if (newContact === props.userId) {
        props.showError("addUserId", "error-display", "FYI You cannot add your own contact.");
        setAddUserButtonDisabled(false);
        throw new Error("You cannot add yourself as a contact.");
      }

      if (snapshot.exists()) {
        const userData = snapshot.val();
        setContactToAdd({
          id: newContact,
          profilePic: userData.profilePic,
          email: userData.email,
        });
        setConfirmingContact(true);
      } else {
        props.showError("addUserId", "error-display", "There is no contact with that ID.");
        document.getElementById("addUserId").style.border = "1.5px solid red";
        setTimeout(() => {
          document.getElementById("addUserId").style.border = "1.5px solid #404040";
        }, 3000);
      }
    } catch (error) {
      console.error("Error while adding contact:", error);
    }
    setAddUserButtonDisabled(false);
  };

  const handleConfirmAddContact = async () => {
    setAddUserButtonDisabled(true);
    try {
      const existingContactsSnapshot = await get(databaseRef(props.db, `users/${props.userId}/contacts`));
      const existingContacts = existingContactsSnapshot.val() || {};

      if (Object.keys(existingContacts).includes(contactToAdd.id)) {
        props.showError("addUserId", "error-display", "Contact already exists in your list.");
        throw new Error("Contact already exists in your list.");
      }

      const updatedContacts = { ...existingContacts, [contactToAdd.id]: true };
      await set(databaseRef(props.db, `users/${props.userId}/contacts`), updatedContacts);

      const otherexistingContactsSnapshot = await get(databaseRef(props.db, `users/${contactToAdd.id}/contacts`));
      const otherexistingContacts = otherexistingContactsSnapshot.val() || {};

      const otherupdatedContacts = { ...otherexistingContacts, [props.userId]: true };
      await set(databaseRef(props.db, `users/${contactToAdd.id}/contacts`), otherupdatedContacts);

      setShowAddContactModal(false);
      setConfirmingContact(false);
      setContactToAdd(null);
      window.location.href = "/";
    } catch (error) {
      console.error("Error while adding contact:", error);
    }
    setAddUserButtonDisabled(false);
  };

  return (
    <div className="home">
      <div className="contacts">
        <div className="contact" style={{ boxShadow: "0px 1px 6px 1px #00000085" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="profile-img-container">
              <img src={props.logedIn && props.profilePic ? props.profilePic : "/img/default-profile-img.png"} alt="" style={{ cursor: "pointer" }} />
            </div>
            <div className="contact-detail">
              <p className="greeting-text">{getGreeting()}</p>
              <p className="name-text">{props.name}</p>
            </div>
          </div>
          {props.logedIn ? (
            <button
              onClick={() => {
                setShowAddContactModal(!showAddContactModal);
                setConfirmingContact(false);
                setContactToAdd(null);
              }}
              className="icons"
            >
              <FaPlus title="Add Contact" />
            </button>
          ) : (
            <Link style={{ color: "#4242d3" }} to={"/signIn"}>
              Sign in
            </Link>
          )}
        </div>

        {props.contactsData.length > 0 ? (
          props.contactsData &&
          props.contactsData.map((data, index) => (
            <React.Fragment key={index}>
              <Link className="contact" id={data.Id} to={data.Id}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="profile-img-container">
                    <img src={data.profileImg} alt="" />
                  </div>
                  <div className="contact-detail">
                    <p className="name-text">{data.name}</p>
                    <p style={{ display: "flex", justifyContent: "space-between", fontSize: "0.8em", color: "#bbbbbb" }}>
                      <span>
                        {data.messages
                          ? data.messages[props.userId]
                            ? data.messages[props.userId][Math.max(...Object.keys(data.messages[props.userId]).map(Number))].message
                            : "Click to open Chat"
                          : "Click to open Chat"}
                      </span>
                    </p>
                  </div>
                </div>
                <span style={{ fontSize: "0.8em", color: "#bbbbbb" }}>
                  {data.messages ? (data.messages[props.userId] ? formatTimestamp(Math.max(...Object.keys(data.messages[props.userId]).map(Number))) : null) : null}
                </span>
              </Link>
            </React.Fragment>
          ))
        ) : props.logedIn ? null : (
          <div className="simple-watermark">
            <span>
              <Link style={{ color: "#4242d3" }} to={"/signIn"}>
                Sign in{" "}
              </Link>
              to View your Contacts here
            </span>
          </div>
        )}
      </div>

      {props.device ? (
        <div className="chats">
          <Header signIn={props.logedIn} logout={props.logout} profilePic={props.profilePic} />
          <Routes>
            {props.contactsData &&
              props.contactsData.map((data, index) => (
                <React.Fragment key={index}>
                  <Route
                    exact
                    path={data.Id}
                    element={
                      <Chat
                        db={props.db}
                        senderId={props.userId}
                        receiverId={data.Id}
                        profilePic={data.profileImg}
                        name={data.name}
                        sendMsg={props.sendMsg}
                        setActiveId={props.setActiveId}
                        logedIn={props.logedIn}
                      />
                    }
                  />
                </React.Fragment>
              ))}
          </Routes>
        </div>
      ) : null}

      {showAddContactModal && (
        <div className="modal-container">
          {confirmingContact ? (
            <div className="modal">
              <div className="question-mark-icon">
                <FaCircleQuestion title="Confirm adding this contact" />
                <FaXmark
                  onClick={() => {
                    setShowAddContactModal(false);
                    setConfirmingContact(false);
                    setContactToAdd(null);
                  }}
                />
              </div>
              <div className="confirmation-info">
                <div className="profile-img-container">
                  <img src={contactToAdd.profilePic || "/img/default-profile-img.png"} alt="Profile" />
                </div>
                <p>{contactToAdd.email}</p>
              </div>
              <div className="confirmation-buttons">
                <button onClick={handleConfirmAddContact} disabled={addUserButtonDisabled}>
                  Confirm
                </button>
                <button
                  onClick={() => {
                    setConfirmingContact(false);
                    setContactToAdd(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <form onSubmit={addContact} className="modal">
              <div className="question-mark-icon">
                <FaCircleQuestion title={`Ask your Friend for his id and paste it in \n the input field to add him to your contacts`} />
                <FaXmark onClick={() => setShowAddContactModal(false)} />
              </div>
              <input value={newContact} onChange={(event) => setNewContact(event.target.value)} required autoComplete="off" placeholder="Enter the User Id" id="addUserId" type="text" />
              <p id="error-display" className="error-display"></p>
              <h2>Your Id</h2>
              <div className="copyId">
                <span>{props.userId}</span>
                <div title="Copy Id" role="button" tabIndex={0} onClick={() => navigator.clipboard.writeText(props.userId).catch((err) => console.error("Unable to copy text", err))}>
                  <FaCopy />
                </div>
              </div>
              <div>
                <button className="primary" type="submit" id="addUserIdOkbtn" disabled={addUserButtonDisabled}>
                  OK
                </button>
                <button className="secondary" type="button" onClick={() => setShowAddContactModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
}
